import { render } from "./PublicationCopy.vue?vue&type=template&id=250e5f5e&scoped=true"
import script from "./PublicationCopy.vue?vue&type=script&lang=js"
export * from "./PublicationCopy.vue?vue&type=script&lang=js"

import "./PublicationCopy.vue?vue&type=style&index=0&id=250e5f5e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250e5f5e"]])

export default __exports__